import { useState, useCallback } from "react"

const createGuestField = (id) => ({
  id,
  sendMethod: "text",
  phoneFields: [{ name: 0, key: Date.now(), isListField: true }],
  emailFields: [{ name: 0, key: Date.now() + 1, isListField: true }]
})

const initialGuestState = [createGuestField(0)]

export const useGuestFields = () => {
  const [guestFields, setGuestFields] = useState(initialGuestState)

  const handleAddGuest = useCallback(() => {
    const newGuestId = guestFields.length
    const newGuest = createGuestField(newGuestId)
    setGuestFields(prev => [...prev, newGuest])
    return newGuestId
  }, [guestFields.length])

  const handleGuestSendMethodChange = useCallback((guestId, method) => {
    setGuestFields(prev => 
      prev.map(guest => 
        guest.id === guestId ? { ...guest, sendMethod: method } : guest
      )
    )
  }, [])

  const handleRemoveGuest = useCallback((guestId) => {
    setGuestFields(prev => prev.filter(g => g.id !== guestId))
  }, [])

  const resetGuestFields = useCallback(() => {
    setGuestFields(initialGuestState)
  }, [])

  return {
    guestFields,
    handleAddGuest,
    handleGuestSendMethodChange,
    handleRemoveGuest,
    resetGuestFields
  }
}
